import React, { useState } from 'react';
import { useParams, Link } from 'react-router-dom';
import api from '../../api';

export function AdminForgotPassword() {
  const [email, setEmail] = useState('');
  const [sent, setSent] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    await api.post('/auth/forgot-password', { email });
    setSent(true);
  };

  return (
    <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', background: 'var(--bj-cream)' }}>
      <form onSubmit={handleSubmit} className="card" style={{ padding: 36, width: 380 }}>
        <h2 style={{ textAlign: 'center' }}>Reset your password</h2>
        {sent ? (
          <p className="form-message success">If that account exists, a reset link has been sent to your email.</p>
        ) : (
          <>
            <div className="form-field" style={{ marginBottom: 14 }}>
              <label htmlFor="email">Email</label>
              <input id="email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} />
            </div>
            <button className="btn btn-primary" style={{ width: '100%' }}>Send Reset Link</button>
          </>
        )}
        <p style={{ textAlign: 'center', marginTop: 14, fontSize: '0.85rem' }}>
          <Link to="/admin/login">Back to login</Link>
        </p>
      </form>
    </div>
  );
}

export function AdminResetPassword() {
  const { token } = useParams();
  const [password, setPassword] = useState('');
  const [done, setDone] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await api.post(`/auth/reset-password/${token}`, { password });
      setDone(true);
    } catch (err) {
      setError(err.response?.data?.message || 'Reset failed');
    }
  };

  return (
    <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', background: 'var(--bj-cream)' }}>
      <form onSubmit={handleSubmit} className="card" style={{ padding: 36, width: 380 }}>
        <h2 style={{ textAlign: 'center' }}>Set a new password</h2>
        {done ? (
          <>
            <p className="form-message success">Password reset! You can now log in.</p>
            <Link to="/admin/login" className="btn btn-primary" style={{ width: '100%', textAlign: 'center', display: 'block' }}>Go to Login</Link>
          </>
        ) : (
          <>
            <div className="form-field" style={{ marginBottom: 14 }}>
              <label htmlFor="password">New Password</label>
              <input id="password" type="password" required minLength={6} value={password} onChange={(e) => setPassword(e.target.value)} />
            </div>
            {error && <p className="form-message error">{error}</p>}
            <button className="btn btn-primary" style={{ width: '100%' }}>Reset Password</button>
          </>
        )}
      </form>
    </div>
  );
}
